const comGalleryGrid = (() => {
  const comGalleryWrap = (document.getElementById("jsComGalleryWrap") != null);
  if (comGalleryWrap) {



    const comGalleryWrap = document.getElementById('jsComGalleryWrap');
    const jsGrid = comGalleryWrap.querySelector('.js-grid');


    var grid = new Muuri(jsGrid, {
      // optionName: value,
      // optionName2: value2,
      // optionName3: value3,
      // optionName4: value4,
      layout: {
        // fillGaps: false,
        // horizontal: false,
        // alignRight: false,
        // alignBottom: false,
        // rounding: false,
      },
      sortData: {
        num: function (item, element) {
          return parseFloat(element.children[0].getAttribute('data-num'));
        }
      }
    });

    grid.sort('num');



  }
})();
export default comGalleryGrid;